import { useState } from "react";

import { SearchIcon } from "../../assets/Icons";
import { Button } from "../../components/Reusable/Button";
import { categoryName } from "../../assets/DemoData";
import { CreateCategoryModal } from "./component";
import {
  InternalContainer,
  ExternalContainer,
} from "../../components/Reusable/Layout";

const Categories = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCreateCategory = (name: string, fields: string[]) => {
    console.log("Create Category:", { name, fields });

    // You could call an API or update local state here
    // setCategories([...categories, { name, fields }])
  };

  return (
    <ExternalContainer>
      <div className="h-screen w-[1030px]">
        <InternalContainer headerText="Categories">
          <div className="flex items-center gap-16   p-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Search for category..."
                className="border p-2 pl-10 rounded-3xl w-[700px] h-[48px] dark:text-white dark:bg-[#FFFFFF1A] bg-[#F4F4F5] dark:border-[#FFFFFF1A]"
              />
              <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                <SearchIcon />
              </div>
            </div>
            <Button
              onClick={() => setIsModalOpen(true)}
              bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
              textColor="text-white"
              borderRadius="rounded-lg"
              className="w-full h-10"
            >
              New Category
            </Button>
          </div>

          <table className="w-full font-inter border border-[#FFFFFF1A] rounded-2xl overflow-hidden">
            <thead>
              <tr className="bg-gray-100 dark:bg-[#FFFFFF1A] text-gray-600 dark:text-white uppercase text-xs bp:text-sm leading-normal h-[50px]">
                <th className="px-6 text-left">Category Name</th>
                <th className="px-6 text-left ">Status</th>
                <th className="px-6 text-left "></th>
              </tr>
            </thead>
            <tbody className="text-gray-600 dark:text-white text-xs bp:text-sm">
              {categoryName.map((category) => (
                <tr
                  key={category.id}
                  className="border-b border-gray-200 h-[50px] hover:bg-gray-100 dark:hover:bg-[#FFFFFF0A] cursor-pointer"
                >
                  <td className="px-6">{category.name}</td>
                  <td className="px-6">{category.status}</td>
                  <td className="px-6">{category.action}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </InternalContainer>
      </div>
      <CreateCategoryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialCategoryName=""
        initialFields={[]}
        onSubmit={handleCreateCategory}
        isEditing={false}
      />
    </ExternalContainer>
  );
};

export default Categories;
